<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <select-project
          v-model="project"
          class="report-base-filter"
          style="min-width: 200px"
        ></select-project>
        <v-select
          :items="dateRangeList"
          :value="dateRangeList[0]"
          label="Period"
          v-on:change="changeTimePeriod"
          hide-details
          class="report-base-filter"
          style="min-width: 200px"
        ></v-select>
        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 150px"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 150px"
        />

        <v-btn color="info" v-on:click="search" class="mt-2" :disabled="loading" :loading="loading">Search</v-btn>
        <export :fields="exportFields" :data="filteredItems" />
      </v-row>
    </v-card>


    <v-card class="col-12 pt-4 pb-4 px-0 mt-4">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        sort-by="created"
        sort-desc
        :height="`calc(100vh - 165px - ${options.accountType  || options.login ? 40 : 0}px - ${options.selectGame || options.selectSystemBrand ? 60 : 0}px - ${!options.pagination && filteredItems.length < 1000 ? 0 : 40}px - ${!options.padding ? 0 : options.padding}px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        fixed-header
        calculate-widths
        @click:row="editItem"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :hide-default-footer="!options.pagination && filteredItems.length < 1000"
        :items-per-page="options.perpage || (!options.perpage && filteredItems.length > 1000 ? 1000 : null) || -1"
        :footer-props="{'items-per-page-options': options.perpage ? ( options.perpage_list || [30, 60, 90]) : [(filteredItems.length > 1000 ? 1000 : null) || -1]}"
        :class="{nowrap, 'table-size-fixed': table_size_fixed, 'report-dt': true}"
        style="z-index: 0; position: relative; width: 100%"
      >
        <template v-slot:item.row_num="{ index }">
          <span> {{ index + 1 }}</span>
        </template>
        <template v-slot:item.login="{ item, header }">
          <a :href="'/user-management/' + (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), ''))" target="_blank" v-if="!item.total">{{ (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), '')) }}</a>
          <div v-if="item.total">Total:</div>
        </template>
        <template v-slot:item.account_id="{ item, header }">
          <a :href="'/user-management/' + (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), ''))" target="_blank" v-if="!item.total">{{ item.account_id }}</a>
        </template>

        <!--        <template v-slot:item.total_deposit="props">-->
        <!--          <v-edit-dialog-->
        <!--            :return-value="props.item.total_deposit"-->
        <!--          >-->
        <!--            {{ props.item.total_deposit }}-->
        <!--            <template v-slot:input>-->
        <!--              <v-text-field-->
        <!--                v-model="props.item.total_deposit"-->
        <!--                label="Edit"-->
        <!--                single-line-->
        <!--                counter-->
        <!--              ></v-text-field>-->
        <!--            </template>-->
        <!--          </v-edit-dialog>-->
        <!--        </template>-->

        <!--        <template v-slot:item.total_deposit_eur="props">-->
        <!--          <v-edit-dialog-->
        <!--            :return-value="props.item.total_deposit_eur"-->
        <!--          >-->
        <!--            {{ props.item.total_deposit_eur }}-->
        <!--            <template v-slot:input>-->
        <!--              <v-text-field-->
        <!--                v-model="props.item.total_deposit_eur"-->
        <!--                label="Edit"-->
        <!--                single-line-->
        <!--                counter-->
        <!--              ></v-text-field>-->
        <!--            </template>-->
        <!--          </v-edit-dialog>-->
        <!--        </template>-->

        <!--        <template v-slot:item.balance="props">-->
        <!--          <v-edit-dialog-->
        <!--            :return-value="props.item.balance"-->
        <!--          >-->
        <!--            {{ props.item.balance }}-->
        <!--            <template v-slot:input>-->
        <!--              <v-text-field-->
        <!--                v-model="props.item.balance"-->
        <!--                label="Edit"-->
        <!--                single-line-->
        <!--                counter-->
        <!--              ></v-text-field>-->
        <!--            </template>-->
        <!--          </v-edit-dialog>-->
        <!--        </template>-->


        <template v-slot:item.frozen="props">
          {{ getStatusName(props.item.frozen) }}
        </template>

        <template v-slot:body.prepend>
          <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                single-line
                class="data-table-finance-filter-select"
                :items="header.value == 'frozen' ? statusList :columnValueList(header.value)"
                :style="{width: (filters[header.value] || {width: false}).width}"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                :style="{width: (filters[header.value] || {width: false}).width}"
                hide-details
              ></v-text-field>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog
        v-model="dialog"
        max-width="700px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit row</span>
          </v-card-title>

          <v-card-text>
            <v-row class="ma-0 pa-0">
              <v-select
                style="max-width: 175px"
                label="Status"
                v-model="editedItem.frozen"
                :items="statusList"
                hide-details
                class="mx-2"
              />
              <v-text-field
                style="max-width: 130px"
                v-model="editedItem.balance"
                label="Balance"
                class="mx-2"
                hide-details
              />
              <v-text-field
                style="max-width: 140px"
                v-model="editedItem.total_deposit"
                label="Total Deposit"
                :suffix="editedItem.currency"
                class="mx-2"
                hide-details
              />
              <v-text-field
                style="max-width: 140px"
                v-model="editedItem.total_deposit_eur"
                label="Total Deposit EUR"
                suffix="EUR"
                class="mx-2"
                hide-details
              />
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="close"
            >
              Cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="save"
            >
              Apply
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
  @import '@/assets/table/report-table.scss';
</style>

<script>
  import moment from 'moment'
  import { find, get, map, filter, toString, debounce } from 'lodash'
  import { API } from '@/utils/api'
  import { filters } from '@/utils/filters'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    name: 'ClosedAccountsByPeriod',
    props: { title: {}, headers: {}, filters: {}, url: {}, defaultParams: { default: () => ({}) }, nowrap: { default: true }, table_size_fixed: { default: false }, options: { default: () => ({}) } },

    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export')
    },

    data: () => ({
      totalItems: -1,
      tableOptions: {},
      filtersD: {},
      project: null,
      loading: false,
      items: [],
      editedIndex: -1,
      editedItem: {},
      dialog: false,
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      dateRangeList,
      accountType: [ 'casino', 'sport' ],
      statusList: [
        { text: 'Open', value: 0 },
        { text: 'Closed', value: 1 },
        { text: 'Frozen', value: 2 },
        { text: 'Temporary Frozen', value: 3 },
        { text: 'Self Exclusion Permanent', value: 4 },
        { text: 'Frozen by Refund', value: 5 },
        { text: 'Frozen by Security Answer', value: 6 },
        { text: 'Not Verified', value: 7 },
        { text: 'Closed by Regulator', value: 8 },
        { text: 'Closed by License', value: 9 },
        { text: 'Gambling Addiction', value: 10 },
        { text: 'Frozen by Suspicion', value: 11 },
        { text: 'Closed by Antifraud', value: 12 },
        { text: 'Closed by Chargeback', value: 13 },
      ]
    }),

    computed: {

      exportFields: function () {
        return map(this.headers, 'value')
      },

      filteredItems: function () {
        return filters(this.items, this.filtersD)
      }
    },

    watch: {
      tableOptions: {
        handler () {
          if (this.options.pagination) {
            this.search()
          }
        },
        deep: true,
      },
      filters: {
        handler: debounce(function () {
          this.filtersD = this.filters
        }, 800),
        deep: true,
      },
    },

    methods: {

      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },

      search: function () {
        this.loading = true
        try {
          if (this.options.accountType) {
            this.defaultParams.account_type = this.accountType
          }

          API.call(this.url, {
            from: this.from,
            to: this.to,
            rule: this.rule,
            ...this.defaultParams,
            ...this.tableOptions
          }, null, this.project).then(resp => {

            this.items = get(resp, 'data', [])

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      editItem (event, { item }) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.items[this.editedIndex], this.editedItem)
        } else {
          this.items.push(this.editedItem)
        }
        this.close()
      },

      getStatusName (status) {
        return (find(this.statusList, { value: status }) || {}).text
      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        return this.items.map(d => d[val])
      }
    },
  }
</script>
